import { Await } from "react-router";
import CustomError from "@components/Error/CustomError";
import { AuthorContext, AuthorPayload } from "@pages/Author/utils/types";
import { useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import AuthorPageContent from "./AuthorPageContent";

/** The main component for the author pages. */
const AuthorPage = (): React.ReactElement => {
  const { context } = useRouteContext<AuthorContext>();

  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }: AuthorPayload) => {
        if (kind !== "author") {
          return <CustomError statusCode={context.statusCode} />;
        }

        return <AuthorPageContent data={data} />;
      }}
    </Await>
  );
};

export default AuthorPage;
